import Image from 'next/image';
import { FC, useEffect } from 'react';

import { GetStartedMicrocopyProps } from 'src/checkout/sections/GetStarted/GetStarted';
import { Button } from 'src/general/components/Button/Button';
import { liveChatStore } from 'src/stores/liveChatStore';

import styles from './GetStartedChatButton.module.scss';

interface GetStartedChatButtonProps {
  microcopy: GetStartedMicrocopyProps;
}

const salesAvatars = [
  { url: '/images/get-started/avatar02.jpg' },
  { url: '/images/get-started/avatar01.jpg' },
  { url: '/images/get-started/avatar03.jpg' },
];

export const GetStartedChatButton: FC<GetStartedChatButtonProps> = ({ microcopy }) => {
  const { chatWidgetLabel } = microcopy;
  const { visibility, hideLiveChat, maximiseLiveChat } = liveChatStore();

  // Initially hide the default chat widget
  useEffect(() => {
    hideLiveChat();
  }, []);

  // Adjust the visibility if it's set to 'minimized'
  useEffect(() => {
    if (visibility === 'minimized') {
      hideLiveChat();
    }
  }, [visibility]);

  return (
    <div className={styles.chatWidgetContainer}>
      <Button variant="tertiary" className={styles.chatWidget} onClick={maximiseLiveChat}>
        <div className={styles.buttonContent}>
          <p className={styles.chatWidgetLabel}> {chatWidgetLabel}</p>
          <div className={styles.avatarContainer}>
            {salesAvatars.map((avatar) => (
              <Image
                src={avatar.url}
                alt="Avatar chat"
                key={avatar.url}
                width={28}
                height={28}
                className={styles.avatar}
              />
            ))}
          </div>
        </div>
      </Button>
    </div>
  );
};
